/*
 * IMPORTS
 */
import { gql } from "@apollo/client"; // NPM: Apollo client for handling graphql request.

/*
 * GRAPH
 */
const Index = gql`
  query SuperAdminStatusCheck {
    SuperAdminStatusCheck {
      message
      status
    }
  }
`;

/*
 * EXPORTS
 */
export default Index;
